import type React from 'react';

import { Alert, Button, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { useEmailDecisionMakerNotification } from './hooks/useEmailDecisionMakerNotification';

type Props = {
	onDismiss?: () => void;
};

export const EmailDecisionMaker: React.FC<Props> = ({ onDismiss }) => {
	const { actions } = useEmailDecisionMakerNotification({ onDismiss });
	const { translate } = useI18n();

	return (
		<Alert
			className="h-full w-full [&>div>div]:flex-row"
			variant="info"
			heading={translate('corgi.petition.starter_dashboard.notifications.email_decision_maker.heading')}
			{...(onDismiss && {
				onDismissClick: actions.handleDismiss,
				dismissButtonAriaLabel: translate(
					'corgi.petition.starter_dashboard.notifications.email_decision_maker.dismiss_button_aria_label',
				),
			})}
			data-qa="starter-can-email-dm-section-message"
		>
			<Text as="p">
				<Translate value="corgi.petition.starter_dashboard.notifications.email_decision_maker.body" />
			</Text>
			<Button className="mt-4" size="x-small" variant="secondary-solid" onClick={actions.handleClick}>
				<Translate value="corgi.petition.starter_dashboard.notifications.email_decision_maker.primary_action_button" />
			</Button>
		</Alert>
	);
};
